import React from 'react';

function CheckListRtl({ disabled = false, variant, ...props }) {
  const fillColor = disabled ? '#999' : variant === 'text' ? '#263238' : '#FFF';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_3397_2785"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3397_2785)">
        <path
          d="M13.6462 15.834L10.6878 12.8757L11.8545 11.709L13.6253 13.4798L17.167 9.93815L18.3337 11.1257L13.6462 15.834ZM13.6462 9.16732L10.6878 6.20898L11.8545 5.04232L13.6253 6.81315L17.167 3.27148L18.3337 4.45898L13.6462 9.16732ZM1.66699 14.1673V12.5007H9.16699V14.1673H1.66699ZM1.66699 7.50065V5.83398H9.16699V7.50065H1.66699Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
}

export default CheckListRtl;